import React from 'react';
import { Box } from '@mui/material';
import ComparisonBarComponent from '@/DesignSystem/features/comparison/ComparisonBar';
import ComparisonSingleTeam from '@/DesignSystem/features/comparison/ComparisonSingleTeam';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';

const getColorForValue = (value) => {
    if (value >= 90) return '#1d6fb1';
    if (value >= 70) return '#00a04f';
    if (value >= 50) return 'rgb(109 156 133)';
    if (value >= 30) return 'rgb(255, 167, 38)';
    return '#ab1414';
};

const DificultadDePartido = ({ home, away }) => {
    const metrics = [
        { key: 'po', label: 'Portero', isHigherBetter: true },
        { key: 'df', label: 'Defensas', isHigherBetter: true },
        { key: 'mc', label: 'Medios', isHigherBetter: true },
        { key: 'dl', label: 'Delanteros', isHigherBetter: true },
        { key: 'pr', label: 'Promedio', isHigherBetter: true },
    ];

    if (home?.dificultad?.pr > 0 && away?.dificultad?.pr > 0) {
        return (
            <CustomSectionWrapper title="Dificultad de partido" mb={2} color="accent2">
                {metrics.map(({ key, label, isHigherBetter }) => {
                    if (!home?.dificultad?.[key] && !away?.dificultad?.[key]) return null;
                    const homeValue = home?.dificultad?.[key] ?? 0;
                    const awayValue = away?.dificultad?.[key] ?? 0;
                    const metricTotal = homeValue + awayValue || 1;

                    return (
                        <ComparisonBarComponent
                            key={key}
                            parameter={label}
                            left={homeValue}
                            right={awayValue}
                            metricTotal={metricTotal}
                            isHigherBetter={isHigherBetter}
                        />
                    );
                })}
            </CustomSectionWrapper>
        );
    }

    if (home?.dificultad?.pr > 0 || away?.dificultad?.pr > 0) {
        const teamDificultad = home?.dificultad?.pr ?? away?.dificultad?.pr ?? 0;
        const borderColor = getColorForValue(teamDificultad);

        return (
            <CustomSectionWrapper title="Dificultad de partido" color={borderColor} mb={2}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', gap: '1%' }}>
                    {metrics.map(({ key, label }) => {
                        if (!home?.dificultad?.[key] && !away?.dificultad?.[key]) return null;
                        const teamValue = home?.dificultad?.[key] ?? away?.dificultad?.[key] ?? 0;
                        const itemBorderColor = getColorForValue(teamValue);

                        return (
                            <ComparisonSingleTeam
                                key={key}
                                parameter={label}
                                teamValue={teamValue}
                                borderColor={itemBorderColor}
                            />
                        );
                    })}
                </Box>
            </CustomSectionWrapper>
        );
    }
};

export default React.memo(DificultadDePartido);
